import React from "react";
import "./index.scss"; // Assurez-vous d'importer le fichier SCSS
import logo from "../../../assets/logo.png";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-top  ">
        <div className="footer-logo-mobile">
          <img src={logo} alt="Logo" />
        </div>
        <div className="footer-left col-lg-3">
          <h3>Fondation Junior</h3>
          <p>
            La Fondation Junior MBUYI œuvre pour améliorer les conditions de vie
            en milieu rural, en fournissant nourriture, eau et infrastructures
            essentielles. Nous offrons des solutions durables pour redonner
            espoir et autonomie aux populations vulnérables.
          </p>
          <div className="social-icons-container text-center d-flex  justify-content-between py-3">
            <a href="#" className="social-icon mx-2 text-white">
              <i className="bi bi-facebook"></i>
            </a>
            <a href="#" className="social-icon mx-2 text-white">
              <i className="bi bi-twitter-x"></i>
            </a>
            <a href="#" className="social-icon mx-2 text-white">
              <i className="bi bi-instagram"></i>
            </a>
          </div>
        </div>
        <div className="footer-right col-lg-5">
          <h3>Liens rapides</h3>
          <hr color="white" />
          <ul>
            <li>
              <Link to="/" onClick={() => window.scrollTo(0, 0)}>
                Accueil
              </Link>
            </li>
            <li>
              <Link to="/aPropo" onClick={() => window.scrollTo(0, 0)}>
                A propos
              </Link>
            </li>
            <li>
              <Link to="/faire-don" onClick={() => window.scrollTo(0, 0)}>
                Faire un Don
              </Link>
            </li>
            <li>
              <Link to="/rejoignez-nous" onClick={() => window.scrollTo(0, 0)}>
                Rejoignez-nous
              </Link>
            </li>
            <li>
              <Link to="/realisation" onClick={() => window.scrollTo(0, 0)}>
                Nos realisation
              </Link>
            </li>
            <li>
              <Link to="/contact" onClick={() => window.scrollTo(0, 0)}>
                Contact
              </Link>
            </li>
            <li>
              <Link to="/mentionsLegales" onClick={() => window.scrollTo(0, 0)}>
                Mentions légales
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-logo">
          <img src={logo} alt="Logo" />
        </div>
        <div className="footer-copyright">
          <p>© 2025 MSIT Conseil. Tous droits réservés.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
